var map = {
	"./60s/applepay.png": 891,
	"./60s/atm.png": 892,
	"./60s/boost.png": 893,
	"./60s/credit-card.png": 894,
	"./60s/dana.png": 895,
	"./60s/duitnow.png": 896,
	"./60s/fpx.png": 897,
	"./60s/gcash.png": 898,
	"./60s/googlepay.png": 899,
	"./60s/grabpay.png": 900,
	"./60s/ibon.png": 901,
	"./60s/internet-banking.png": 902,
	"./60s/jko.png": 903,
	"./60s/linepay.png": 904,
	"./60s/maya.png": 905,
	"./60s/maybankqr.png": 906,
	"./60s/ovo.png": 907,
	"./60s/payid.png": 908,
	"./60s/paypal.png": 909,
	"./60s/promptpay.png": 910,
	"./60s/qris.png": 911,
	"./60s/qrph.png": 912,
	"./60s/shopeepay.png": 913,
	"./60s/touchngo.png": 914,
	"./60s/truemoney.png": 915,
	"./60s/upiqr.png": 916,
	"./60s/vietqr.png": 917,
	"./60s/wechatpay.png": 918,
	"./60s/zalopay.png": 919,
	"./alipay.png": 1053,
	"./amex.png": 1054,
	"./applepay.png": 920,
	"./boost.png": 1055,
	"./credit.png": 838,
	"./dana.png": 921,
	"./duitnow.png": 922,
	"./fpx.png": 1056,
	"./gcash.png": 839,
	"./googlepay.png": 923,
	"./gopay.png": 1057,
	"./grabpay.png": 924,
	"./internet-banking.png": 840,
	"./linepay.png": 925,
	"./mastercard.png": 1058,
	"./maya.png": 926,
	"./maybankqr.png": 927,
	"./ovo.png": 928,
	"./payid.png": 929,
	"./paynow.png": 841,
	"./paypal.png": 930,
	"./pepay-atm.png": 811,
	"./pepay-ibon.png": 1059,
	"./pepay-jko.png": 931,
	"./pepay-store.png": 812,
	"./promptpay.png": 932,
	"./qr-modal/kosikorn-bank.png": 438,
	"./qr-modal/ktb-bank.png": 439,
	"./qr-modal/promptpay-logo.png": 440,
	"./qr-modal/scb-bank.png": 441,
	"./qr-modal/shopeepay-logo.png": 442,
	"./qr-modal/truemoney-logo.png": 443,
	"./qris.png": 933,
	"./qrph.png": 934,
	"./shopeepay.png": 935,
	"./touchngo.png": 1060,
	"./truemoney.png": 936,
	"./unionpay.png": 1061,
	"./upiqr.png": 937,
	"./vietqr.png": 938,
	"./visa.png": 1062,
	"./wallet-money.svg": 1072,
	"./wallet.png": 939,
	"./wechatpay.png": 842,
	"./zalopay.png": 940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1066;